import React from "react";
import { Box, Typography, IconButton, Tooltip, Button } from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import CustomTableWithPagination from "../../../components/customTable/CustomTable";
import CommonButton from "../../../components/CommonButton/CommonButton";
import { Video } from "./types";
import { getFormattedDate } from "../../../utils/commonFunctions";

interface VideoTableProps {
  videos: Video[];
  status: "idle" | "fetching" | "success" | "error";
  onActivate: (videoId: string) => void;
  onDeactivate: (videoId: string) => void;
  onDownload: (videoURL: string) => void;
}

const VideoTable: React.FC<VideoTableProps> = ({
  videos,
  status,
  onActivate,
  onDeactivate,
  onDownload
}) => {
  const columns = [
    {
      id: "AppId",
      label: "App ID",
      minWidth: 170,
      align: "left" as const,
      format: (value: string) => value || "-"
    },
    {
      id: "DateCreated",
      label: "Created At",
      minWidth: 170,
      align: "left" as const,
      format: (value: string) => (value ? getFormattedDate(value) : "-")
    },
    {
      id: "IsActive",
      label: "Status",
      minWidth: 100,
      align: "left" as const,
      format: (value: number) => (
        <Button
          variant="contained"
          size="small"
          sx={{
            backgroundColor: value === 1 ? "success.main" : "error.main",
            color: "white",
            textTransform: "none",
            minWidth: "100px",
            "&:hover": {
              backgroundColor: value === 1 ? "success.dark" : "error.dark"
            }
          }}
        >
          {value === 1 ? "Active" : "Inactive"}
        </Button>
      )
    },

    {
      id: "actions",
      label: "Actions",
      minWidth: 200,
      align: "left" as const,
      format: (_: any, row: Video) => (
        <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
          {row.IsActive === 1 ? (
            <CommonButton
              variant="outlined"
              color="error"
              onClick={() => onDeactivate(row.MerchantVideoId)}
            >
              Deactivate
            </CommonButton>
          ) : (
            <CommonButton
              variant="outlined"
              color="success"
              onClick={() => onActivate(row.MerchantVideoId)}
            >
              Activate
            </CommonButton>
          )}
        </Box>
      )
    },
    {
      id: "VideoURL",
      label: "Video URL",
      minWidth: 300,
      align: "left" as const,
      format: (value: string) => (
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          {value ? (
            <>
              <Typography
                sx={{
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                  cursor: "pointer",
                  color: "#223354",
                  "&:hover": {
                    color: "#223354",
                    textDecoration: "underline"
                  }
                }}
                onClick={() =>
                  value ? window.open(value, "_blank") : () => {}
                }
              >
                {value || "-"}
              </Typography>
              {/* <Tooltip title="Download Video">
                <IconButton
                  onClick={() => onDownload(value)}
                  size="small"
                  color="primary"
                  sx={{
                    color: "#223354",
                    "&:hover": { color: "#223354" }
                  }}
                >
                  <DownloadIcon />
                </IconButton>
              </Tooltip> */}
            </>
          ) : (
            "-"
          )}
        </Box>
      )
    }
  ];

  return (
    <CustomTableWithPagination
      columns={columns}
      data={videos}
      apiStatus={status}
      payloadSize={10}
      currentPage={0}
      totalCount={videos.length}
      lastEvaluatedKey={null}
      handleChangeRowsPerPage={() => {}}
      handleChangePage={() => {}}
      isShowPagination={false}
      noDataFoundMessage="No Data Available"
    />
  );
};

export default VideoTable;
